import React from "react";
import BusinessLayout from "../../layouts/BusinessLayout";
import GallerySection from "../../components/organization/GallerySection";

const BusinessGallery: React.FC = () => {
  return <BusinessLayout>{(business) => <GallerySection business={business} />}</BusinessLayout>;
};

export default BusinessGallery;
